import { makeAutoObservable } from 'mobx'
import { getPlanById, getPlanByName } from '../services/planAPI'
import { makePersistable } from 'mobx-persist-store'

class PlanStore {
  loadingPlans = false
  plans = []
  currentPlan = {}
  error = null

  constructor() {
    makeAutoObservable(this)
    makePersistable(this, {
      name: 'PlanStore',
      properties: ['plans', 'currentPlan'],
    })
  }

  /**
   * Sets the current plan.
   * @param plan - The plan to set as current.
   */
  setCurrentPlan = plan => {
    this.currentPlan = plan
  }

  /**
   * Clears the current plan and reports.
   */
  clearCurrentPlan = () => {
    this.currentPlan = null
  }

  /**
   * Invalidates the current error.
   */
  invalidateError = () => {
    this.error = null
  }
}

export default PlanStore
